import React from 'react';
import { ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { resources } from '../data/mock';

const extraResources = [
  ...resources,
  { title: 'Pest Control Industry Benchmark Report 2025', type: 'REPORT', desc: 'See how your business stacks up against industry leaders.', cta: 'Download', img: 'https://images.unsplash.com/photo-1612947890379-5146d3b4de07?crop=entropy&cs=srgb&fm=jpg&w=900&q=80' },
  { title: 'Mastering Route Optimization', type: 'WEBINAR', desc: 'Cut fuel costs by 28% with smart route planning.', cta: 'Watch Now', img: 'https://images.pexels.com/photos/19789841/pexels-photo-19789841.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { title: 'From 5 Trucks to 50: A Growth Playbook', type: 'EBOOK', desc: 'The 7 hires that unlocked 10x revenue at AAA Pest Pros.', cta: 'Read Now', img: 'https://images.unsplash.com/photo-1670989292166-8b20b9530438?crop=entropy&cs=srgb&fm=jpg&w=900&q=80' },
];

export default function Resources() {
  return (
    <div className="bg-white">
      <Header />
      <section className="bg-gradient-to-b from-slate-50 to-white pt-16 pb-10">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <p className="text-[#8BC53F] font-bold tracking-widest text-sm mb-3">RESOURCES</p>
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight text-slate-900">Learn, Grow, Thrive</h1>
          <p className="mt-6 text-slate-600 text-xl">Tools, insights, and stories from the best in pest.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          {extraResources.map(r => (
            <Card key={r.title} className="pp-lift overflow-hidden border-0 shadow-md bg-white">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={r.img} alt={r.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"/>
              </div>
              <div className="p-6">
                <span className="text-[10px] font-bold tracking-widest text-[#6FA82C]">{r.type}</span>
                <h3 className="text-xl font-bold text-slate-900 mt-2 leading-snug">{r.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{r.desc}</p>
                <a href="#" className="mt-4 inline-flex items-center gap-1 text-[#8BC53F] font-semibold text-sm hover:gap-2 transition-all">{r.cta} <ArrowRight className="w-4 h-4"/></a>
              </div>
            </Card>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
